import React, { useState } from "react";
import { ListItemText } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";
import MenuApp from "./MenuApp";


const Liste = () => {

  const { filteredServices } = useSelector((state: IReduxState) => state.siteWeb);


  return (
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {filteredServices.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp
                        item={item}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemButton>
                        <ListItemText
                          primary={item.libService}
                        /> 
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
  );
};
export default Liste;
